import React from 'react';
export function Footer() {
  return <footer className="py-7 px-4 sm:px-6 bg-brand-green-dark text-center text-white/60 text-[10px] sm:text-xs" data-id="element-67">
      <p className="leading-snug max-w-2xl mx-auto font-medium mb-4" data-id="element-68">
        © 2026 Dog Trainer Pro™ — All Rights Reserved. The content of this
        page is for educational and informational purposes only and does not
        replace professional canine behavior certification or veterinary advice.
        For cases involving serious aggression or biting history, always refer
        clients to a Board-Certified Veterinary Behaviorist (DACVB) or Certified
        Applied Animal Behaviorist (CAAB). Always follow appropriate safety
        guidelines when working with dogs.
      </p>
      <div className="flex justify-center gap-3 sm:gap-4 font-bold tracking-wide uppercase" data-id="element-69">
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-70">
          Terms &amp; Conditions
        </a>
        <span className="text-white/20" data-id="element-71">·</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-72">
          Privacy Policy
        </a>
        <span className="text-white/20" data-id="element-73">·</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-74">
          Contact
        </a>
      </div>
    </footer>;
}